<template>
  <div>
    <div>
      <loader :loading="loading"></loader>
      <run-model-modal v-if="related_model_in_modal" :model="related_model_in_modal" @close_modal="close_run_model_modal"></run-model-modal>
      <primary-button
        data-testid="train-config-train-btn"
        :disabled="train_config.archived || related_active_jobs.length > 0 || trainLimitReached || noValidationImages"
        @pressed="train()"
        :label="$t('models_and_train_configs.label_button_train')"
      >
      </primary-button>
      <v-btn icon v-if="related_models.length>0" @click="show_run_model_modal(related_models)" color="primary" x-small>
        <v-icon>far fa-circle-play</v-icon>
      </v-btn>
      <v-tooltip v-if="noValidationImages" location="bottom">
        <template v-slot:activator="{ props }">
          <v-btn icon v-bind="props" color="orange" size="x-small">
            <v-icon>mdi-alert</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('models_and_train_configs.no_validation_images') }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/form/PrimaryButton";
import RunModelModal from "@/components/run_model_modal/RunModelModal";
import LoadProjectsMixin from "@/mixins/LoadProjectsMixin";
import Loader from "@/components/layout/loader";
import { isFailedTrainJob, parseJobDescription } from "@/utils/trainMetrics";


export default {
  mixins: [LoadProjectsMixin],
  name: "TrainConfigTrainActionsCell",
  props: {
    train_config: Object,
    models: Array,
    jobs: Array,
    trainLimitReached: {
      type: Boolean,
      default: false,
    },
  },
  components: {PrimaryButton, RunModelModal, Loader},
  data () {
    return {
      'loading': false,
      'related_model_in_modal': null,
      'noValidationImages': false,
    }
  },
  methods: {
    async checkIfNoValidationImagesForTrainConfig() {
      const response = await this.$api.asset.number_of_validation_images_for_train_config(this.train_config.id)
      if (response && response.number_of_validation_images === 0) {
        this.noValidationImages = true;
      }
    },
    close_run_model_modal() {
      this.related_model_in_modal = null
    },
    async dismissFailedJobs() {
      const failed = this.related_failed_jobs;
      for (const job of failed) {
        await this.$api.job.delete(job);
      }
    },
    async train() {
      this.loading = true;
      let meta = JSON.parse(this.train_config.meta);
      if(!meta['mixup']) {
        alert('Train config outdated due to Box21 update, please edit and save again.');
        this.loading = false;
        return;
      }
      // Clear stuck Failed jobs so a new train can be claimed.
      try {
        await this.dismissFailedJobs();
      } catch (e) {
        console.error('Failed to dismiss failed train jobs', e);
      }
      let response = await this.$api.job.start_train_job(this.train_config.id);
      this.$emit('load_jobs_request');
      this.loading = false;

      if (response && typeof response === 'object' && response.limit_reached && response.limit_type === 'TRAIN_LIMIT') {
        this.$emit("train-limit-reached");
      }
      if (response && typeof response === 'object' && response.error && response.error === 'No validation images found') {
        this.noValidationImages = true;
      }
    },
    show_run_model_modal(related_models) {
      this.related_model_in_modal = related_models[0]
    },
  },
  computed: {
    related_failed_jobs() {
      return (this.jobs || []).filter((job) => {
        const meta = parseJobDescription(job);
        return (
          Number(meta.train_config_id) === Number(this.train_config.id) &&
          isFailedTrainJob(job)
        );
      });
    },
    related_active_jobs() {
      // Failed jobs must not block Retrain — they stay processed=0 after worker errors.
      return (this.jobs || []).filter((job) => {
        const meta = parseJobDescription(job);
        return (
          job.processed != 1 &&
          Number(meta.train_config_id) === Number(this.train_config.id) &&
          !isFailedTrainJob(job)
        );
      });
    },
    related_models() {
      if(!this.models) {
        return [];
      }
      return this.models
        .filter(model => model.train_config_id === this.train_config.id)
        .filter(model => this.train_config.archived || !model.archived);
    },
  },
  mounted() {
    this.checkIfNoValidationImagesForTrainConfig();
  },
}
</script>

<style scoped>

</style>